<template>
  <router-view></router-view>
</template>

<script>
export default {
    name: "ps-wrapper"
};
</script>

<style>
</style>